<template>
  <span :class="'ms- ' + ms.style + ' ' + ms.icon">{{ ms.text }}</span>
</template>

<script>
export default {
  name: "main-status",
  props: {
    ms: {
      type: Object,
      required: false,
      default() {
        return {
          text: "",
          style: "",
          icon: "",
        };
      },
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";
.ms- {
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  border-radius: 30px;
  text-align: center;
  font-weight: 700;
  position: relative;
}
.ms-green {
  background: #9dc50d;
}
.ms-red {
  background: #ff6145;
}
.ms-green-red {
  background: linear-gradient(-45deg, #ff6145 50%, #9dc50d 50%);
}
.ms-dubbio {
  background: #fdd835;
}
.ms-inf {
  background: #fff;
  color: #ff6145;
  font-size: 23px;
  // border: 3px solid #ff6145;
  // box-sizing: content-box;
}
.ms-sq {
  background: #ff6145;
  border-radius: 2px;
  border: 1px solid #d13317;
  width: 17px;
  height: 23px;
  margin-left: 5px;
  margin-right: 5px;
}
.ms-black {
  background: #303030;
}
.ms-politico {
  background: #bdbdbd;
}
.ms-def {
  background: white;
  color: #303030;
}
.ms-covid {
  background-image: url("#{$cross-s3}/pf/covid.png");
  background-color: white;
  background-size: cover;
}
.ms-in {
  background: #ff6145;
  font-size: 9px;
  &:before {
    position: absolute;
    top: -5px;
    right: -5px;
    content: "";
    width: 10px;
    height: 10px;
    background-image: url("#{$cross-s3}/misc/arrow-in.png");
    background-size: contain;
    box-shadow: 0 0 0 3px rgb(64 81 88);
    background-color: rgb(64 81 88);
    border-radius: 100px;
  }
}

.ms-out {
  background: #9dc50d;
  font-size: 9px;
  &:before {
    position: absolute;
    top: -5px;
    right: -5px;
    content: "";
    width: 10px;
    height: 10px;
    background-image: url("#{$cross-s3}/misc/arrow-out.png");
    background-size: contain;
    box-shadow: 0 0 0 3px rgb(64 81 88);
    background-color: rgb(64 81 88);
    border-radius: 100px;
  }
}
.ms-uff:after {
  background: url("#{$cross-s3}/misc/voto-ufficiale.png");
  position: absolute;
  bottom: -2px;
  right: -3px;
  content: "";
  width: 8px;
  height: 8px;
  background-size: cover;
  box-shadow: 0 0 0 3px rgb(64 81 88);
  border-radius: 100px;
}
</style>